export interface CrewsheetCanvasser {
  turf_name?: string | null;
}

export interface CrewsheetSiteroute {
  name?: string | null;
  siteroute_name?: string | null;
}

export interface CrewsheetCrew {
  id: number;
  siteroute_name?: string | null;
  siteroute?: CrewsheetSiteroute | null;
  canvassers?: CrewsheetCanvasser[] | null;
}

export function getCrewDisplayName(crew: CrewsheetCrew): string {
  if (crew.siteroute?.name) {
    return crew.siteroute.name;
  }

  const siterouteName =
    crew.siteroute_name ?? crew.siteroute?.siteroute_name;
  if (siterouteName) return siterouteName;

  const turfNames = [
    ...new Set(
      (crew.canvassers ?? [])
        .map((c) => c.turf_name)
        .filter((name): name is string => Boolean(name))
    ),
  ];
  if (turfNames.length) return turfNames.join(", ");

  return `Crew #${crew.id}`;
}
